var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconComponent)?_c(_vm.iconComponent,{tag:"component",staticClass:"base-icon",attrs:{"size":_vm.sizeVal,"stroke-width":_vm.strokeWidth,"color":_vm.colorVal}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }